import { createContext } from 'react'
import type { Context } from '~/types'

export default createContext<Context>({})
